export class RegisterResponse {
    'accountId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return RegisterResponse.attributeTypeMap;
    }
    constructor() {
    }
}
